import { TextInputField, Textarea, Button, Pane, Heading, toaster } from 'evergreen-ui';
import { UploadIcon } from 'evergreen-ui';
import { addAnnouncement } from '../services/announcementServices';
import FileUploaderMultipleUploadDemo from '../commons/FileUploaderMultipleUploadDemo';

const AddAnnouncementForm = ({ newAnnouncement, setNewAnnouncement, setIsAdding, setAnnouncements, isDirector, userId, fetchAnnouncements, onAnnouncementAdded }) => {
    
    newAnnouncement.attachments = newAnnouncement.attachments || [];

    const handleAddAnnouncement = async () => {
        try {
            const formData = new FormData();
            formData.append('title', newAnnouncement.title);
            formData.append('body', newAnnouncement.body);

            if (newAnnouncement.attachments.length > 0) {
                newAnnouncement.attachments.forEach((file, index) => {
                    formData.append(`attachments[${index}]`, file);
                });
            }

            const addedAnnouncement = await addAnnouncement(formData);

            if (addedAnnouncement.success) {
                const updatedAnnouncements = await fetchAnnouncements();
                setAnnouncements(updatedAnnouncements?.data ?? []);
                onAnnouncementAdded && onAnnouncementAdded();
                setNewAnnouncement({ title: '', body: '', attachments: [] });
                setIsAdding(false);
                toaster.success('Annuncio pubblicato con successo.');
            } else {
                toaster.danger('Errore durante l\'aggiunta dell\'annuncio.');
            }
        } catch (error) {
            console.error('Errore durante l\'aggiunta dell\'annuncio:', error);
            toaster.danger('Errore durante l\'aggiunta dell\'annuncio.');
        }
    };

    const handleFilesChange = (acceptedFiles) => {
        setNewAnnouncement((prev) => ({
            ...prev,
            attachments: acceptedFiles,
        }));
    };

    return (
        <Pane>
            <Heading size={600} marginBottom={16}>
                Aggiungi nuovo annuncio
            </Heading>
            <TextInputField
                label="Titolo"
                placeholder="Inserisci il titolo dell'annuncio..."
                value={newAnnouncement.title}
                onChange={(e) => setNewAnnouncement({ ...newAnnouncement, title: e.target.value })}
                marginBottom={16}
            />
            <Textarea
                label="Corpo"
                placeholder="Scrivi il corpo dell'annuncio..."
                value={newAnnouncement.body}
                onChange={(e) => setNewAnnouncement({ ...newAnnouncement, body: e.target.value })}
                marginBottom={16}
                resize="none"
                height={120}
            />
            {isDirector && (
                <FileUploaderMultipleUploadDemo onFilesChange={handleFilesChange} />
            )}
            <Button 
                iconBefore={UploadIcon}
                appearance="primary" 
                intent='success'
                onClick={() => handleAddAnnouncement()} 
                width="8.4rem"
            >
                Pubblica
            </Button>
        </Pane>
    );
};

export default AddAnnouncementForm;